/**
 * @generated SignedSource<<9e33af46d8ea8f77847bad93be62466c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type clientQueryLoaderHomeQuery$variables = {
  advertisersQueueName: string;
  excludeSsrContentEntityIds: ReadonlyArray<string | null | undefined>;
  isAsiaEdition: boolean;
  mostPopularQueueName: string;
  multimediaQueueName: string;
  trendingTopicsQueueName: string;
};
export type clientQueryLoaderHomeQuery$data = {
  readonly advertisers: {
    readonly items: {
      readonly " $fragmentSpreads": FragmentRefs<"advertisersQueueItemConnection">;
    } | null | undefined;
  } | null | undefined;
  readonly china: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly hongKong?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly lifestyle: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly peopleCulture: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly style: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly twia?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"mostPopularQueueQuery" | "multimediaQuery" | "sectionTopQuery" | "trendingTopicTopic">;
};
export type clientQueryLoaderHomeQuery = {
  response: clientQueryLoaderHomeQuery$data;
  variables: clientQueryLoaderHomeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "advertisersQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeSsrContentEntityIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isAsiaEdition"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mostPopularQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "multimediaQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "trendingTopicsQueueName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "advertisersQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_4"
    }
  }
],
v4 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "entityIds",
      "variableName": "excludeSsrContentEntityIds"
    }
  ],
  "kind": "ObjectValue",
  "name": "exclude"
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 7
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge"
      }
    ],
    "storageKey": null
  }
],
v8 = [
  {
    "alias": null,
    "args": (v6/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v7/*: any*/),
    "storageKey": null
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_2"
    }
  }
],
v10 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_94"
    }
  }
],
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v12 = [
  (v4/*: any*/),
  (v11/*: any*/)
],
v13 = [
  {
    "alias": null,
    "args": (v12/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v7/*: any*/),
    "storageKey": null
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_318202"
    }
  }
],
v15 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_72"
    }
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_323045"
    }
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v24 = [
  (v23/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v28 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v31 = [
  (v20/*: any*/)
],
v32 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v17/*: any*/),
        (v32/*: any*/),
        (v33/*: any*/),
        (v34/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v38 = [
  (v18/*: any*/),
  (v22/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v40 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v38/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v38/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    (v41/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v45 = [
  (v18/*: any*/)
],
v46 = {
  "kind": "InlineFragment",
  "selections": (v45/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": (v45/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v46/*: any*/),
        (v47/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v36/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v49/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v51 = {
  "kind": "InlineFragment",
  "selections": [
    (v36/*: any*/),
    (v37/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/),
    (v44/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v48/*: any*/),
        (v50/*: any*/)
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v53 = [
  (v52/*: any*/)
],
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v53/*: any*/),
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "types",
      "storageKey": null
    },
    (v22/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v57 = {
  "kind": "InlineFragment",
  "selections": [
    (v48/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v58 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v45/*: any*/),
            "type": "Content",
            "abstractKey": "__isContent"
          },
          (v34/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v59 = [
  {
    "alias": null,
    "args": (v6/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v58/*: any*/),
    "storageKey": null
  },
  (v22/*: any*/)
],
v60 = [
  {
    "alias": null,
    "args": (v12/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v58/*: any*/),
    "storageKey": null
  },
  (v22/*: any*/)
],
v61 = [
  (v11/*: any*/)
],
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v21/*: any*/),
    (v25/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v54/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": (v53/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v53/*: any*/),
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v17/*: any*/),
        (v46/*: any*/),
        (v47/*: any*/),
        (v34/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v65/*: any*/),
    (v50/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v71 = {
  "alias": "size1200x800",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1200x800"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v23/*: any*/),
    (v27/*: any*/),
    (v21/*: any*/),
    (v71/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v73 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/),
    (v36/*: any*/),
    (v19/*: any*/),
    (v37/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/),
    (v44/*: any*/),
    (v66/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v20/*: any*/),
            (v63/*: any*/)
          ],
          "type": "Section",
          "abstractKey": null
        },
        (v33/*: any*/),
        (v34/*: any*/),
        (v73/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v76 = [
  (v75/*: any*/)
],
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v76/*: any*/),
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v75/*: any*/),
    (v52/*: any*/)
  ],
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    (v49/*: any*/),
    (v41/*: any*/),
    (v42/*: any*/),
    (v80/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        (v80/*: any*/),
        (v22/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v17/*: any*/),
            (v18/*: any*/),
            (v36/*: any*/),
            (v19/*: any*/),
            (v37/*: any*/),
            (v39/*: any*/),
            (v40/*: any*/),
            (v44/*: any*/),
            (v66/*: any*/)
          ],
          "type": "BaseWithApplicationAndUrlAlias",
          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
        }
      ],
      "storageKey": null
    },
    (v56/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "multimediaEmbed",
      "plural": false,
      "selections": (v76/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v18/*: any*/),
            (v22/*: any*/),
            (v20/*: any*/),
            (v54/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVideoContent",
      "storageKey": null
    },
    (v55/*: any*/),
    (v63/*: any*/),
    (v57/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    (v43/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v83 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }
],
v84 = [
  (v20/*: any*/),
  (v22/*: any*/)
],
v85 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "100x100"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v24/*: any*/),
      "storageKey": "style(filter:{\"style\":\"100x100\"})"
    }
  ],
  "storageKey": null
},
v86 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v31/*: any*/),
            "type": "Topic",
            "abstractKey": null
          },
          (v32/*: any*/),
          (v73/*: any*/),
          (v34/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v87 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "disableFollow",
    "storageKey": null
  }
],
v88 = {
  "kind": "InlineFragment",
  "selections": (v87/*: any*/),
  "type": "Author",
  "abstractKey": null
},
v89 = {
  "kind": "InlineFragment",
  "selections": (v87/*: any*/),
  "type": "Topic",
  "abstractKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "Queue",
  "kind": "LinkedField",
  "name": "topStories",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": (v6/*: any*/),
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v18/*: any*/),
                    (v19/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Topic",
                      "kind": "LinkedField",
                      "name": "topics",
                      "plural": true,
                      "selections": [
                        (v18/*: any*/),
                        (v62/*: any*/),
                        (v22/*: any*/),
                        (v63/*: any*/),
                        (v19/*: any*/),
                        (v20/*: any*/),
                        (v64/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v17/*: any*/),
                            (v36/*: any*/),
                            (v37/*: any*/),
                            (v39/*: any*/),
                            (v40/*: any*/),
                            (v44/*: any*/),
                            (v66/*: any*/),
                            (v88/*: any*/),
                            (v89/*: any*/)
                          ],
                          "type": "BaseWithApplicationAndUrlAlias",
                          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                        }
                      ],
                      "storageKey": null
                    },
                    (v67/*: any*/),
                    (v68/*: any*/),
                    (v69/*: any*/),
                    (v70/*: any*/),
                    (v26/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "images",
                      "plural": true,
                      "selections": [
                        (v23/*: any*/),
                        (v27/*: any*/),
                        (v21/*: any*/),
                        (v71/*: any*/),
                        (v28/*: any*/),
                        {
                          "alias": "landscape250x99",
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "filter",
                              "value": {
                                "style": "landscape_250_99"
                              }
                            }
                          ],
                          "concreteType": "ImageStyle",
                          "kind": "LinkedField",
                          "name": "style",
                          "plural": false,
                          "selections": (v24/*: any*/),
                          "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
                        }
                      ],
                      "storageKey": null
                    },
                    (v29/*: any*/),
                    (v30/*: any*/),
                    (v74/*: any*/),
                    (v77/*: any*/),
                    (v78/*: any*/),
                    (v79/*: any*/),
                    (v51/*: any*/),
                    (v81/*: any*/),
                    (v82/*: any*/)
                  ],
                  "type": "Content",
                  "abstractKey": "__isContent"
                },
                (v34/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v17/*: any*/),
    (v88/*: any*/),
    (v89/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v92 = [
  (v18/*: any*/),
  (v20/*: any*/),
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Queue",
    "kind": "LinkedField",
    "name": "subSections",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": (v61/*: any*/),
        "concreteType": "QueueItemConnection",
        "kind": "LinkedField",
        "name": "items",
        "plural": false,
        "selections": (v86/*: any*/),
        "storageKey": "items(first:5)"
      },
      (v22/*: any*/)
    ],
    "storageKey": null
  },
  (v90/*: any*/),
  (v22/*: any*/),
  (v91/*: any*/)
],
v93 = [
  (v18/*: any*/),
  (v20/*: any*/),
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Queue",
    "kind": "LinkedField",
    "name": "subSections",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 6
          }
        ],
        "concreteType": "QueueItemConnection",
        "kind": "LinkedField",
        "name": "items",
        "plural": false,
        "selections": (v86/*: any*/),
        "storageKey": "items(first:6)"
      },
      (v22/*: any*/)
    ],
    "storageKey": null
  },
  (v90/*: any*/),
  (v22/*: any*/),
  (v91/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clientQueryLoaderHomeQuery",
    "selections": [
      {
        "alias": "advertisers",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "advertisersQueueItemConnection"
              }
            ],
            "storageKey": "items(first:20)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "china",
        "args": (v3/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v8/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_4\"})"
      },
      {
        "condition": "isAsiaEdition",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "hongKong",
            "args": (v9/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_2\"})"
          }
        ]
      },
      {
        "alias": "lifestyle",
        "args": (v10/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v13/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_94\"})"
      },
      {
        "alias": "peopleCulture",
        "args": (v14/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v13/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_318202\"})"
      },
      {
        "alias": "style",
        "args": (v15/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v13/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_72\"})"
      },
      {
        "condition": "isAsiaEdition",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "twia",
            "args": (v16/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "mostPopularQueueName",
            "variableName": "mostPopularQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "mostPopularQueueQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "multimediaQueueName",
            "variableName": "multimediaQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "multimediaQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "excludeSsrContentEntityIds",
            "variableName": "excludeSsrContentEntityIds"
          },
          {
            "kind": "Variable",
            "name": "isAsiaEdition",
            "variableName": "isAsiaEdition"
          }
        ],
        "kind": "FragmentSpread",
        "name": "sectionTopQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "trendingTopicsQueueName",
            "variableName": "trendingTopicsQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "trendingTopicTopic"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "clientQueryLoaderHomeQuery",
    "selections": [
      {
        "alias": "advertisers",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsor",
                                "kind": "LinkedField",
                                "name": "sponsor",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v25/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v22/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v23/*: any*/),
                              (v27/*: any*/),
                              (v21/*: any*/),
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v35/*: any*/),
                          (v51/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v20/*: any*/),
                                      (v18/*: any*/),
                                      (v54/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:20)"
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "china",
        "args": (v3/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v59/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_4\"})"
      },
      {
        "alias": "lifestyle",
        "args": (v10/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v60/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_94\"})"
      },
      {
        "alias": "peopleCulture",
        "args": (v14/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v60/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_318202\"})"
      },
      {
        "alias": "style",
        "args": (v15/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v60/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_72\"})"
      },
      {
        "alias": "mostPopularQueueQuery",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "mostPopularQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v61/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v18/*: any*/),
                              (v62/*: any*/),
                              (v22/*: any*/),
                              (v63/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v64/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v44/*: any*/),
                                  (v66/*: any*/)
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              }
                            ],
                            "storageKey": null
                          },
                          (v67/*: any*/),
                          (v68/*: any*/),
                          (v69/*: any*/),
                          (v70/*: any*/),
                          (v26/*: any*/),
                          (v72/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v74/*: any*/),
                          (v77/*: any*/),
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v51/*: any*/),
                          (v81/*: any*/),
                          (v82/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:5)"
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "multimedia",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "multimediaQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v83/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleTypeSegment",
                            "kind": "LinkedField",
                            "name": "types",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleType",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": (v84/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v26/*: any*/),
                          (v72/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v35/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v18/*: any*/),
                              (v62/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Gallery",
                            "abstractKey": null
                          },
                          (v51/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v54/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegment",
                                "kind": "LinkedField",
                                "name": "sections",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Section",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": (v84/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v85/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v65/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v82/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PodcastSection",
                                "kind": "LinkedField",
                                "name": "podcastSections",
                                "plural": true,
                                "selections": [
                                  (v85/*: any*/),
                                  (v20/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Podcast",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:4)"
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "chinaSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "4"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": (v92/*: any*/),
        "storageKey": "section(filter:{\"entityId\":\"4\"})"
      },
      {
        "alias": "lifestyleSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "94"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v20/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "subSections",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v83/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v86/*: any*/),
                "storageKey": "items(first:4)"
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          (v90/*: any*/),
          (v22/*: any*/),
          (v91/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"94\"})"
      },
      {
        "alias": "peopleCultureSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "318202"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": (v92/*: any*/),
        "storageKey": "section(filter:{\"entityId\":\"318202\"})"
      },
      {
        "alias": "wellnessSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "24"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": (v92/*: any*/),
        "storageKey": "section(filter:{\"entityId\":\"24\"})"
      },
      {
        "alias": "styleSection",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "72"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v20/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "subSections",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v5/*: any*/)
                ],
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v86/*: any*/),
                "storageKey": "items(first:7)"
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          (v90/*: any*/),
          (v22/*: any*/),
          (v91/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"72\"})"
      },
      {
        "alias": "trendingTopicsQueue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "trendingTopicsQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v61/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*: any*/),
                          (v18/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v36/*: any*/),
                              (v19/*: any*/),
                              (v37/*: any*/),
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v44/*: any*/),
                              (v66/*: any*/),
                              (v88/*: any*/),
                              (v89/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          }
                        ],
                        "type": "Topic",
                        "abstractKey": null
                      },
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:5)"
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "isAsiaEdition",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "hongKong",
            "args": (v9/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v59/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_2\"})"
          },
          {
            "alias": "hongKongSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "2"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v93/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"2\"})"
          }
        ]
      },
      {
        "condition": "isAsiaEdition",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "twia",
            "args": (v16/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v59/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
          },
          {
            "alias": "twiaSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "323045"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v93/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"323045\"})"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ad4e0edda37b8ba32c172ae658ab8861",
    "id": null,
    "metadata": {},
    "name": "clientQueryLoaderHomeQuery",
    "operationKind": "query",
    "text": "query clientQueryLoaderHomeQuery(\n  $advertisersQueueName: String!\n  $excludeSsrContentEntityIds: [String]!\n  $isAsiaEdition: Boolean!\n  $mostPopularQueueName: String!\n  $multimediaQueueName: String!\n  $trendingTopicsQueueName: String!\n) {\n  advertisers: queue(filter: {name: $advertisersQueueName}) {\n    items(first: 20) {\n      ...advertisersQueueItemConnection\n    }\n    id\n  }\n  china: queue(filter: {name: \"section_top_4\"}) {\n    items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  hongKong: queue(filter: {name: \"section_top_2\"}) @skip(if: $isAsiaEdition) {\n    items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  lifestyle: queue(filter: {name: \"section_top_94\"}) {\n    items(first: 5, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  peopleCulture: queue(filter: {name: \"section_top_318202\"}) {\n    items(first: 5, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  style: queue(filter: {name: \"section_top_72\"}) {\n    items(first: 5, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  twia: queue(filter: {name: \"section_top_323045\"}) @include(if: $isAsiaEdition) {\n    items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  ...mostPopularQueueQuery_KkbCb\n  ...multimediaQuery_4rBIay\n  ...sectionTopQuery_2SQznT\n  ...trendingTopicTopic_4tMn4o\n}\n\nfragment advertisersQueueItemConnection on QueueItemConnection {\n  edges {\n    node {\n      __typename\n      ... on Content {\n        __isContent: __typename\n        entityId\n        ...homeAdvertiserContentItemContent\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentCoverImageContent_34Njms on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3MAHTt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_4Kx38 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_ScPJx on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityFollowMenuQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n    }\n    ... on Section {\n      name\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on Section {\n  name\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetLabelContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n    sections {\n      value {\n        name\n        id\n      }\n    }\n  }\n  ... on Gallery {\n    __typename\n  }\n  ... on Video {\n    __typename\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment homeAdvertiserContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  urlAlias\n  topics {\n    sponsor {\n      name\n      type\n      id\n    }\n    id\n  }\n  ...hooksContentItemProvidersContent_2aLOLQ\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1uhIyn\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_1aiv1W on Content {\n  __isContent: __typename\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1gwcYn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1uhIyn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2aLOLQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3MAHTt\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2gnGW2 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3SIuYu on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_4Kx38\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment mostPopularQueueQuery_KkbCb on Query {\n  mostPopularQueueQuery: queue(filter: {name: $mostPopularQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...homeSecondaryContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment multimediaContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Gallery {\n    images {\n      __typename\n    }\n  }\n  ...entityLink\n  ...helpersGetLabelContent\n  ...hooksContentItemProvidersContent_3SIuYu\n}\n\nfragment multimediaPodcastContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Article {\n    images {\n      style(filter: {style: \"100x100\"}) {\n        url\n      }\n    }\n  }\n  ... on Podcast {\n    podcastSections {\n      images {\n        style(filter: {style: \"100x100\"}) {\n          url\n        }\n      }\n      name\n      id\n    }\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n}\n\nfragment multimediaQuery_4rBIay on Query {\n  multimedia: queue(filter: {name: $multimediaQueueName}) {\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            types {\n              value {\n                name\n                id\n              }\n            }\n          }\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...multimediaContentItemContent\n            ...multimediaPodcastContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment oneSectionTopWidgetQueue on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...homeSecondaryContentItemContent\n      ...sectionTopLeadPrimaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sectionTopLeadPrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...entityLink\n  ...contentCoverImageContent_34Njms\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_2gnGW2\n}\n\nfragment sectionTopLeadSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...entityLink\n  ...contentCoverImageContent_ScPJx\n  ...helpersUseContentSponsorContent\n  ...helpersCheckHasLiveTagArticle\n  ...hooksContentItemProvidersContent_1gwcYn\n}\n\nfragment sectionTopQuery_2SQznT on Query {\n  chinaSection: section(filter: {entityId: \"4\"}) {\n    ...subsectionMenuSection\n    name\n    subSections {\n      items(first: 5) {\n        edges {\n          ...subsectionMenuQueue\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          ...oneSectionTopWidgetQueue\n          ...twoSectionTopWidgetQueue\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  hongKongSection: section(filter: {entityId: \"2\"}) @skip(if: $isAsiaEdition) {\n    ...subsectionMenuSection\n    name\n    subSections {\n      items(first: 6) {\n        edges {\n          ...subsectionMenuQueue\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          ...oneSectionTopWidgetQueue\n          ...twoSectionTopWidgetQueue\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  lifestyleSection: section(filter: {entityId: \"94\"}) {\n    ...subsectionMenuSection\n    name\n    subSections {\n      items(first: 4) {\n        edges {\n          ...subsectionMenuQueue\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          ...oneSectionTopWidgetQueue\n          ...twoSectionTopWidgetQueue\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  peopleCultureSection: section(filter: {entityId: \"318202\"}) {\n    ...subsectionMenuSection\n    name\n    subSections {\n      items(first: 5) {\n        edges {\n          ...subsectionMenuQueue\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          ...oneSectionTopWidgetQueue\n          ...twoSectionTopWidgetQueue\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  wellnessSection: section(filter: {entityId: \"24\"}) {\n    ...subsectionMenuSection\n    name\n    subSections {\n      items(first: 5) {\n        edges {\n          ...subsectionMenuQueue\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          ...oneSectionTopWidgetQueue\n          ...twoSectionTopWidgetQueue\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  styleSection: section(filter: {entityId: \"72\"}) {\n    ...subsectionMenuSection\n    name\n    subSections {\n      items(first: 7) {\n        edges {\n          ...subsectionMenuQueue\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          ...oneSectionTopWidgetQueue\n          ...twoSectionTopWidgetQueue\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  twiaSection: section(filter: {entityId: \"323045\"}) @include(if: $isAsiaEdition) {\n    ...subsectionMenuSection\n    name\n    subSections {\n      items(first: 6) {\n        edges {\n          ...subsectionMenuQueue\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          ...oneSectionTopWidgetQueue\n          ...twoSectionTopWidgetQueue\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment subsectionMenuQueue on QueueItemsEdge {\n  ...entityFollowMenuQueueItemsEdge\n}\n\nfragment subsectionMenuSection on Section {\n  ...followButtonBase\n  entityId\n  name\n  urlAlias\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment trendingTopicTopic_4tMn4o on Query {\n  trendingTopicsQueue: queue(filter: {name: $trendingTopicsQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Topic {\n            ...entityLink\n            ...followButtonBase\n            name\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment twoSectionTopWidgetQueue on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...homeSecondaryContentItemContent\n      ...sectionTopLeadSecondaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eaa97dd64300400effd0744f579f9745";

export default node;
